import { CharacterStyleCatalog } from "./CharacterStyleCatalog";
import { CemilanBanuaPromo } from "./CemilanBanuaPromo";
import { Ai } from "./Ai";
import React from "react";
import { Composition } from "remotion";
import { KyuStoreFFBreakdown } from "./KyuStoreFFBreakdown";
import { KyuStoreRombakGaul } from "./KyuStoreRombakGaul";
import { KyuStoreSatirePro } from "./KyuStoreSatirePro";
import { KyuStoreSatireAntiRibet } from "./KyuStoreSatireAntiRibet";
import { MyComposition } from "./Composition";
import { KyuStorePromoComposition } from "./KyuStorePromo";
import { ClaudeMascotComposition } from "./ClaudeMascotPromo";
import { JackRobertsComposition } from "./JackRobertsScene";
import { NixlevPromoComposition } from "./NixlevPromo";
import { NixlevExplainerComposition } from "./NixlevExplainer";
import { NixlevMaster60s } from "./NixlevMaster60s";
import { NixlevKineticFinal } from "./NixlevKineticFinal";
import { NixlevConcept1 } from "./NixlevConcept1";
import { NixlevConcept2 } from "./NixlevConcept2";
import { NixlevConcept3 } from "./NixlevConcept3";
import { NixlevSilentCashier } from "./NixlevSilentCashier";
import { NixlevCleanEditorial } from "./NixlevCleanEditorial";
import { NixlevFloatingMotion } from "./NixlevFloatingMotion";
import { NixlevTikTokAdCompliant } from "./NixlevTikTokAdCompliant";
import { NixlevFrictionlessOpsi2 } from "./NixlevFrictionlessOpsi2";
import { KyuStoreCleanEsport } from "./KyuStoreCleanEsport";
import { KyuStorePinterestEsport } from "./KyuStorePinterestEsport";
import { KyuStoreEsportsBroadcast } from "./KyuStoreEsportsBroadcast";
import { KyuStoreAntiMinusOpsi3 } from "./KyuStoreAntiMinusOpsi3";
import { KyuStoreCinematic3DProof } from "./KyuStoreCinematic3DProof";
import { KyuStoreMaster1MinPlus } from "./KyuStoreMaster1MinPlus";
import { KyuStoreElementsAction } from "./KyuStoreElementsAction";
import { KyuStoreNotifPromo } from "./KyuStoreNotifPromo";
import { KyuStoreExplainerPro } from "./KyuStoreExplainerPro";
import { KyuStoreCinematicTactical } from "./KyuStoreCinematicTactical";
import { KyuStoreFlagshipMaster } from "./KyuStoreFlagshipMaster";
import { KyuStoreMetaHirara } from "./KyuStoreMetaHirara";
import { KyuStore3DFactory } from "./KyuStore3DFactory";
import { KyuStoreReal3D } from "./KyuStoreReal3D";
import { TransisiHardCut, TransisiPushThrough, TransisiCardMorph } from "./TransitionShowcase";
import { MotionVfxShowcase } from "./MotionVfxShowcase";
import { KyuStoreFeedStill } from "./KyuStoreFeedStill";
import { AIAgentAppleKeynote } from "./AIAgentAppleKeynote";
import { KyuStore3Pasien } from "./KyuStore3Pasien";
import { ZuraClassaiPhoneDemo } from "./ZuraClassaiPhoneDemo";
import { TestZuraGLBComposition } from "./TestZuraGLBLoader";
import { TestOPZuraPreview } from "./TestOPZuraPreview";
import {
  KineticTypographyShowcase,
  CaptionThemesShowcase,
} from "./StyleShowcaseKineticAndCaptions";
import { FreshNeoBrutalist } from "./FreshNeoBrutalist";
import { FreshLiquidChrome } from "./FreshLiquidChrome";
import { FreshSwissEditorial } from "./FreshSwissEditorial";
import { KyuStoreFCMobileBrutalist } from "./KyuStoreFCMobileBrutalist";
import { KyuStoreWebLuminousBento } from "./KyuStoreWebLuminousBento";
import { KyuStoreWebDarkTitanium } from "./KyuStoreWebDarkTitanium";
import { KyuStoreNeoStreetwear } from "./KyuStoreNeoStreetwear";
import { KyuStoreSwissPaper } from "./KyuStoreSwissPaper";
import { KyuStoreSplitChallenge } from "./KyuStoreSplitChallenge";
import { KyuStoreRaihanStyle } from "./KyuStoreRaihanStyle";
import {
  KyuStoreFlashSaleNeoBrutalist,
  KyuStoreFlashSaleSwissPaper,
} from "./KyuStoreFlashSalePromo";
import {
  KyuStoreBauhausCalendar,
  KyuStoreMonolithBento,
} from "./KyuStoreFlashSaleFreshV2";
import { KyuStoreMonolithBentoFull } from "./KyuStoreMonolithBentoFull";
import { ElementLibraryShowcase } from "./ElementLibraryShowcase";
import { ThirdPartyElementsShowcase } from "./ThirdPartyElementsShowcase";
import { HermesAgentExplainer } from "./HermesAgentExplainer";
import { HermesTeamCompanyExplainer } from "./HermesTeamCompanyExplainer";
import { ClipperProRemix } from "./ClipperProRemix";
import { KyuStoreFreeFireUnpopular } from "./KyuStoreFreeFireUnpopular";
import { SoclVslRecreation } from "./SoclVslRecreation";
import { KyuStoreWdpPromo32k } from "./KyuStoreWdpPromo32k";
import { HermesAntiSlopShowcase } from "./HermesAntiSlopShowcase";
import { FreshNeoBrutalistLight } from "./FreshNeoBrutalistLight";
import { KyuStoreMotionShowcase } from "./KyuStoreMotionShowcase";
import { ZuraAIDebutRemotion } from "./ZuraAIDebutRemotion";
import { ZuraSolopreneurTeam } from "./ZuraSolopreneurTeam";
import { ZuraStopCloudViral } from "./ZuraStopCloudViral";
import { ZuraMascotPreview } from "./ZuraMascotPreview";
import { AntiSlopMascotShowcase } from "./AntiSlopMascotShowcase";
import { OPZuraPoseCatalog } from "./OPZuraPoseCatalog";
import { ZuraAIRealityCheck } from "./ZuraAIRealityCheck";
import { ZuraHermesHardwareMyth } from "./ZuraHermesHardwareMyth";
import { ObsidianVioletSaaS } from "./templates/ObsidianVioletSaaS";

import { ZuraRemotionUpdateShowcase } from "./ZuraRemotionUpdateShowcase";
import { ZuiPetIntro } from "./ZuiPetIntro";
import { ZuiAndBuddy } from "./ZuiAndBuddy";
import { IndoVoiceAIPerkenalan } from "./IndoVoiceAIPerkenalan";
import { ZuraAutonomousAIPerkenalan } from "./ZuraAutonomousAIPerkenalan";
import { ZuiAndBoloArenaShowcase } from "./ZuiAndBoloArenaShowcase";
import { KuroAndSparkShowcase } from "./KuroAndSparkShowcase";
import { KuroSoloShowcase } from "./KuroSoloShowcase";
import { SparkSoloShowcase } from "./SparkSoloShowcase";
import { SiklusSyukurNeon } from "./SiklusSyukurNeon";
import { SejarahSumurBor } from "./SejarahSumurBor";
import { SejarahSumurBorRefStyle } from "./SejarahSumurBorRefStyle";
import { CreatorStudioShowcase } from "./CreatorStudioShowcase";
import { SocialMediaDetailedMotion } from "./SocialMediaDetailedMotion";
import { AIKasinoKataMotion } from "./AIKasinoKataMotion";
import { AITechEditorialMotion } from "./AITechEditorialMotion";

export const RemotionRoot: React.FC = () => {
  return (
    <>
      <Composition
        id="AITechEditorialMotion"
        component={AITechEditorialMotion}
        durationInFrames={1310}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="AIKasinoKataMotion"
        component={AIKasinoKataMotion}
        durationInFrames={1310}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="CreatorStudioShowcase"
        component={CreatorStudioShowcase}
        durationInFrames={235}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="SejarahSumurBorRefStyle"
        component={SejarahSumurBorRefStyle}
        durationInFrames={235}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="SocialMediaDetailedMotion"
        component={SocialMediaDetailedMotion}
        durationInFrames={180}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="SejarahSumurBor"
        component={SejarahSumurBor}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="CemilanBanuaPromo"
        component={CemilanBanuaPromo}
        durationInFrames={1130}
        fps={60}
        width={1080}
        height={1920}
      />
      <Composition
        id="SiklusSyukurNeon"
        component={SiklusSyukurNeon}
        durationInFrames={1005}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="ZuraStopCloudViral"
        component={ZuraStopCloudViral}
        durationInFrames={651}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="CharacterStyleCatalog"
        component={CharacterStyleCatalog}
        durationInFrames={120}
        fps={30}
        width={1920}
        height={1080}
      />
<Composition
  id="TestOPZuraPreview"
  component={TestOPZuraPreview}
  durationInFrames={30}
  fps={30}
  width={1080}
  height={1920}
/>
<Composition
  id="TestZuraGLBComposition"
  component={TestZuraGLBComposition}
  durationInFrames={30}
  fps={30}
  width={1080}
  height={1920}
/>
<Composition
  id="ZuraClassaiPhoneDemo"
  component={ZuraClassaiPhoneDemo}
  durationInFrames={1177}
  fps={30}
  width={1080}
  height={1920}
/>
<Composition
  id="ZuraAutonomousAIPerkenalan"
        component={ZuraAutonomousAIPerkenalan}
        durationInFrames={880}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="IndoVoiceAIPerkenalan"
        component={IndoVoiceAIPerkenalan}
        durationInFrames={640}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KuroSoloShowcase"
        component={KuroSoloShowcase}
        durationInFrames={180}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="SparkSoloShowcase"
        component={SparkSoloShowcase}
        durationInFrames={180}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KuroAndSparkShowcase"
        component={KuroAndSparkShowcase}
        durationInFrames={180}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="ZuiAndBoloArenaShowcase"
        component={ZuiAndBoloArenaShowcase}
        durationInFrames={180}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="ZuiAndBuddy"
        component={ZuiAndBuddy}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="ZuiPetIntro"
        component={ZuiPetIntro}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="ObsidianVioletSaaS"
        component={ObsidianVioletSaaS}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="ZuraHermesHardwareMyth"
        component={ZuraHermesHardwareMyth}
        durationInFrames={1280}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="ZuraAIRealityCheck"
        component={ZuraAIRealityCheck}
        durationInFrames={1350}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="OPZuraPoseCatalog"
        component={OPZuraPoseCatalog}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="AntiSlopMascotShowcase"
        component={AntiSlopMascotShowcase}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="ZuraMascotPreview"
        component={ZuraMascotPreview}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="ZuraSolopreneurTeam"
        component={ZuraSolopreneurTeam}
        durationInFrames={1670}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="HermesAntiSlopShowcase"
        component={HermesAntiSlopShowcase}
        durationInFrames={500}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreWdpPromo32k"
        component={KyuStoreWdpPromo32k}
        durationInFrames={684}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="SoclVslRecreation"
        component={SoclVslRecreation}
        durationInFrames={684}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="ZuraAIDebut"
        component={ZuraAIDebutRemotion}
        durationInFrames={1710}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreMotionShowcase"
        component={KyuStoreMotionShowcase}
        durationInFrames={840}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FreshNeoBrutalistLight"
        component={FreshNeoBrutalistLight}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreFreeFireUnpopular"
        component={KyuStoreFreeFireUnpopular}
        durationInFrames={1310}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreFFBreakdown"
        component={KyuStoreFFBreakdown}
        durationInFrames={1380}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="ClipperProRemix"
        component={ClipperProRemix}
        durationInFrames={474}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="HermesTeamCompanyExplainer"
        component={HermesTeamCompanyExplainer}
        durationInFrames={1800}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="HermesAgentExplainer"
        component={HermesAgentExplainer}
        durationInFrames={2435}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreRombakGaul"
        component={KyuStoreRombakGaul}
        durationInFrames={2028}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreSatirePro"
        component={KyuStoreSatirePro}
        durationInFrames={2028}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreSatireAntiRibet"
        component={KyuStoreSatireAntiRibet}
        durationInFrames={2028}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="ThirdPartyElementsShowcase"
        component={ThirdPartyElementsShowcase}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="ElementLibraryShowcase"
        component={ElementLibraryShowcase}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreMonolithBentoFull"
        component={KyuStoreMonolithBentoFull}
        durationInFrames={500}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreBauhausCalendar"
        component={KyuStoreBauhausCalendar}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreMonolithBento"
        component={KyuStoreMonolithBento}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreFlashSaleNeo"
        component={KyuStoreFlashSaleNeoBrutalist}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreFlashSaleSwiss"
        component={KyuStoreFlashSaleSwissPaper}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreRaihanStyle"
        component={KyuStoreRaihanStyle}
        durationInFrames={540} // 18.0s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreSplitChallenge"
        component={KyuStoreSplitChallenge}
        durationInFrames={937} // 31.25s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreNeoStreetwear"
        component={KyuStoreNeoStreetwear}
        durationInFrames={937} // 31.25s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreSwissPaper"
        component={KyuStoreSwissPaper}
        durationInFrames={937} // 31.25s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreWebDarkTitanium"
        component={KyuStoreWebDarkTitanium}
        durationInFrames={937} // 31.25s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreWebLuminousBento"
        component={KyuStoreWebLuminousBento}
        durationInFrames={937} // 31.25s @ 30fps (Exact Mastered VO Sync)
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreFCMobileBrutalist"
        component={KyuStoreFCMobileBrutalist}
        durationInFrames={565} // 18.83s @ 30fps (Exact Mastered VO Sync)
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FreshNeoBrutalist"
        component={FreshNeoBrutalist}
        durationInFrames={180}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FreshLiquidChrome"
        component={FreshLiquidChrome}
        durationInFrames={180}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="FreshSwissEditorial"
        component={FreshSwissEditorial}
        durationInFrames={180}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KineticTypographyShowcase"
        component={KineticTypographyShowcase}
        durationInFrames={150}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="CaptionThemesShowcase"
        component={CaptionThemesShowcase}
        durationInFrames={150}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="AIAgentAppleKeynote"
        component={AIAgentAppleKeynote}
        durationInFrames={1350} // 45.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStore3Pasien"
        component={KyuStore3Pasien}
        durationInFrames={1773} // 59.10s @ 30fps (matching BOZ voiceover)
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreMetaHirara"
        component={KyuStoreMetaHirara}
        durationInFrames={1320} // 44.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreReal3D"
        component={KyuStoreReal3D}
        durationInFrames={450} // 15.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStore3DFactory"
        component={KyuStore3DFactory}
        durationInFrames={450} // 15.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreFlagshipMaster"
        component={KyuStoreFlagshipMaster}
        durationInFrames={1010} // 33.67s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreCinematicTactical"
        component={KyuStoreCinematicTactical}
        durationInFrames={540} // 18.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreExplainerPro"
        component={KyuStoreExplainerPro}
        durationInFrames={720} // 24.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreNotifPromo"
        component={KyuStoreNotifPromo}
        durationInFrames={900} // 30.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreElementsAction"
        component={KyuStoreElementsAction}
        durationInFrames={246} // 8.20s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreMaster1MinPlus"
        component={KyuStoreMaster1MinPlus}
        durationInFrames={2400} // 80.00s (1m 20s) @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreCinematic3DProof"
        component={KyuStoreCinematic3DProof}
        durationInFrames={246} // 8.20s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreAntiMinusOpsi3"
        component={KyuStoreAntiMinusOpsi3}
        durationInFrames={1220} // 40.67s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStorePinterestEsport"
        component={KyuStorePinterestEsport}
        durationInFrames={360} // 12.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreEsportsBroadcast"
        component={KyuStoreEsportsBroadcast}
        durationInFrames={360} // 12.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreCleanEsport"
        component={KyuStoreCleanEsport}
        durationInFrames={360} // 12.00s @ 30fps (Sample Visual)
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="NixlevFrictionlessOpsi2"
        component={NixlevFrictionlessOpsi2}
        durationInFrames={945} // 31.50s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="NixlevTikTokAdCompliant"
        component={NixlevTikTokAdCompliant}
        durationInFrames={900} // 30.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TransisiHardCut"
        component={TransisiHardCut}
        durationInFrames={180} // 6.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TransisiPushThrough"
        component={TransisiPushThrough}
        durationInFrames={180} // 6.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="TransisiCardMorph"
        component={TransisiCardMorph}
        durationInFrames={180} // 6.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="NixlevFloatingMotion"
        component={NixlevFloatingMotion}
        durationInFrames={600} // 20.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="NixlevCleanEditorial"
        component={NixlevCleanEditorial}
        durationInFrames={600} // 20.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="KyuStoreFeedStill"
        component={KyuStoreFeedStill}
        durationInFrames={1}
        fps={30}
        width={1080}
        height={1080}
      />
      <Composition
        id="NixlevSilentCashier"
        component={NixlevSilentCashier}
        durationInFrames={1350} // 45.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="MotionVfxShowcase"
        component={MotionVfxShowcase}
        durationInFrames={234} // 7.8s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="NixlevConcept1"
        component={NixlevConcept1}
        durationInFrames={1530} // 51.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="NixlevConcept2"
        component={NixlevConcept2}
        durationInFrames={1560} // 52.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="NixlevConcept3"
        component={NixlevConcept3}
        durationInFrames={1320} // 44.00s @ 30fps
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="NixlevKineticFinal"
        component={NixlevKineticFinal}
        durationInFrames={1700}
        fps={30}
        width={1080}
        height={1920}
      />
      <Composition
        id="NixlevMaster60s"
        component={NixlevMaster60s}
        durationInFrames={1800}
        fps={30}
        width={1080}
        height={1920}
      />
      <NixlevExplainerComposition />
      <NixlevPromoComposition />
      <JackRobertsComposition />
      <ClaudeMascotComposition />
      <KyuStorePromoComposition />
      <MyComposition />
      <Composition
        id="ai"
        component={Ai}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="ZuraRemotionUpdateShowcase"
        component={ZuraRemotionUpdateShowcase}
        durationInFrames={540}
        fps={30}
        width={1080}
        height={1920}
      />
    </>
  );
};
